export default {
  basicViewItem: [{
    prop: 'bill_no',
    label: '',
    Object: 'value'
  }, {
    prop: 'user',
    label: '',
    Object: 'value'
  }, {
    prop: 'status',
    label: '',
    Object: 'value'
  }, {
    prop: 'total_amount',
    label: '',
    Object: 'value'
  }, {
    prop: 'total_paid_amount',
    label: '',
    Object: 'value'
  }, {
    prop: 'total_due',
    label: '',
    Object: 'value'
  }, {
    prop: 'due_date',
    label: '',
    Object: 'value'
  }],
  customerViewItem: [{
    prop: 'user_name'
  }, {
    prop: 'contact_number'
  }, {
    prop: 'customer_id'
  }, {
    prop: 'email'
  }],
  orderTableItem: [{
    prop: 'shop',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'order_detail',
    label: '',
    Object: 'value',
    width: '350'
  }, {
    prop: 'delivery_detail',
    label: '',
    Object: 'value',
    width: '350'
  }, {
    prop: 'status',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'admin_remarks',
    label: '',
    Object: 'value',
    width: '150'
  }],
  paymentHistoryTableItem: [{
    prop: 'payment_type',
    label: '',
    Object: 'value',
    width: '100'
  }, {
    prop: 'item',
    label: '',
    Object: 'value',
    width: '100'
  }, {
    prop: 'paid_amount',
    label: '',
    Object: 'value',
    width: '100'
  }, {
    prop: 'admin_remarks',
    label: '',
    Object: 'value',
    width: '250'
  }, {
    prop: 'shop_payment_no',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
